// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tv-display {
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0e17 0%, #1a1f2e 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.tv-display.fullscreen {
  cursor: none;
}

.tv-display.fullscreen:hover {
  cursor: default;
}

/* Loading State */
.tv-loading {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.tv-spinner {
  width: 80px;
  height: 80px;
  border: 6px solid var(--border-color);
  border-top-color: var(--accent-blue);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: var(--spacing-lg);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Error State */
.tv-error {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  text-align: center;
}

.tv-error h2 {
  margin: var(--spacing-lg) 0 var(--spacing-sm);
  color: var(--text-primary);
  font-size: 2rem;
}

.tv-error button {
  margin-top: var(--spacing-lg);
  padding: var(--spacing-md) var(--spacing-xl);
  background: var(--accent-blue);
  border: none;
  border-radius: var(--radius-md);
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

/* Main Content */
.tv-main {
  flex: 1 1;
  padding: var(--spacing-lg) var(--spacing-xl);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

/* Single View Layout — AI banner on top, content below */
.tv-single-view {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
  min-height: 0;
  overflow: hidden;
}

/* AI widget — thin, full-width banner at top */
.tv-single-ai {
  flex-shrink: 0;
  max-height: 120px;
  overflow: hidden;
}

/* Content area: sidebar + main side by side */
.tv-single-content {
  flex: 1 1;
  display: grid;
  grid-template-columns: minmax(280px, 320px) 1fr;
  grid-template-rows: 1fr;
  gap: var(--spacing-lg);
  min-height: 0;
  overflow: hidden;
}

/* Left sidebar: location card only */
.tv-single-sidebar {
  min-height: 0;
  max-height: 100%;
  overflow: auto;
}

/* Main area: map (biggest) + forecast strip below */
.tv-single-main {
  display: grid;
  grid-template-rows: 3fr 1fr;
  gap: var(--spacing-md);
  min-height: 0;
  overflow: hidden;
}

.tv-single-map {
  min-height: 0;
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--bg-card);
  border: 2px solid var(--border-color);
}

.tv-single-forecast {
  min-height: 0;
  overflow: hidden;
}

.tv-no-forecast {
  padding: var(--spacing-lg);
  text-align: center;
  color: var(--text-muted);
  background: var(--bg-card);
  border-radius: var(--radius-lg);
}

/* Grid View */
.tv-grid-view {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-lg);
  min-height: 0;
}

.tv-grid-item {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* Overview */
.tv-overview {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.tv-overview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-lg);
  flex: 1 1;
  min-height: 0;
}

.tv-overview-item {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-color);
  padding: var(--spacing-md);
  min-height: 0;
  overflow: hidden;
}

.tv-overview-map {
  flex: 1 1;
  min-height: 150px;
  border-radius: var(--radius-md);
  overflow: hidden;
}

/* Location Indicators */
.tv-indicators {
  display: flex;
  justify-content: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md);
}

.indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--text-muted);
  background: transparent;
  cursor: pointer;
  transition: all var(--transition-fast);
}

.indicator:hover {
  border-color: var(--accent-blue);
}

.indicator.active {
  background: var(--accent-blue);
  border-color: var(--accent-blue);
  transform: scale(1.2);
}

/* Controls Hint */
.tv-controls-hint {
  position: fixed;
  bottom: var(--spacing-md);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: var(--spacing-lg);
  padding: var(--spacing-sm) var(--spacing-lg);
  background: rgba(0, 0, 0, 0.7);
  border-radius: var(--radius-md);
  font-size: 0.8rem;
  color: var(--text-muted);
  opacity: 0;
  transition: opacity var(--transition-normal);
  backdrop-filter: blur(8px);
  z-index: 100;
}

.tv-display:hover .tv-controls-hint {
  opacity: 1;
}

.tv-display.fullscreen .tv-controls-hint {
  opacity: 0;
}

.tv-controls-hint kbd {
  padding: 2px 6px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-family: inherit;
  font-size: 0.75rem;
}

/* Back Link */
.tv-back-link {
  position: fixed;
  top: var(--spacing-md);
  left: var(--spacing-md);
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-sm) var(--spacing-md);
  background: rgba(0, 0, 0, 0.5);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  opacity: 0;
  transition: opacity var(--transition-normal);
  backdrop-filter: blur(8px);
  z-index: 100;
}

.tv-display:hover .tv-back-link {
  opacity: 1;
}

.tv-back-link:hover {
  background: rgba(0, 0, 0, 0.7);
  color: var(--text-primary);
}

/* Progress Bar */
.tv-progress-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--bg-secondary);
  z-index: 50;
}

.tv-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-blue), var(--accent-cyan));
  animation: progress linear forwards;
  width: 0;
}

@keyframes progress {
  from { width: 0; }
  to { width: 100%; }
}

/* Responsive */
@media (max-width: 1400px) {
  .tv-single-content {
    grid-template-columns: minmax(240px, 280px) 1fr;
  }
}

@media (max-width: 1100px) {
  .tv-single-content {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  .tv-single-ai {
    max-height: 100px;
  }

  .tv-overview-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 800px) {
  .tv-single-ai {
    max-height: 80px;
  }

  .tv-overview-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TVDisplay.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,SAAO;EACP,aAAa;EACb,+CAA+C;EAC/C,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;EACxB,UAAU;EACV,4CAA4C;EAC5C,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,4CAA4C;EAC5C,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,0EAA0E;EAC1E,mCAAmC;EACnC,QAAQ;AACV;;AAEA;EACE,OAAO,QAAQ,EAAE;EACjB,KAAK,WAAW,EAAE;AACpB;;AAEA,eAAe;AACf;EACE;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".tv-display {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0a0e17 0%, #1a1f2e 100%);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.tv-display.fullscreen {\n  cursor: none;\n}\n\n.tv-display.fullscreen:hover {\n  cursor: default;\n}\n\n/* Loading State */\n.tv-loading {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n}\n\n.tv-spinner {\n  width: 80px;\n  height: 80px;\n  border: 6px solid var(--border-color);\n  border-top-color: var(--accent-blue);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: var(--spacing-lg);\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Error State */\n.tv-error {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.tv-error h2 {\n  margin: var(--spacing-lg) 0 var(--spacing-sm);\n  color: var(--text-primary);\n  font-size: 2rem;\n}\n\n.tv-error button {\n  margin-top: var(--spacing-lg);\n  padding: var(--spacing-md) var(--spacing-xl);\n  background: var(--accent-blue);\n  border: none;\n  border-radius: var(--radius-md);\n  color: white;\n  font-size: 1.2rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n/* Main Content */\n.tv-main {\n  flex: 1;\n  padding: var(--spacing-lg) var(--spacing-xl);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n}\n\n/* Single View Layout — AI banner on top, content below */\n.tv-single-view {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* AI widget — thin, full-width banner at top */\n.tv-single-ai {\n  flex-shrink: 0;\n  max-height: 120px;\n  overflow: hidden;\n}\n\n/* Content area: sidebar + main side by side */\n.tv-single-content {\n  flex: 1;\n  display: grid;\n  grid-template-columns: minmax(280px, 320px) 1fr;\n  grid-template-rows: 1fr;\n  gap: var(--spacing-lg);\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* Left sidebar: location card only */\n.tv-single-sidebar {\n  min-height: 0;\n  max-height: 100%;\n  overflow: auto;\n}\n\n/* Main area: map (biggest) + forecast strip below */\n.tv-single-main {\n  display: grid;\n  grid-template-rows: 3fr 1fr;\n  gap: var(--spacing-md);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.tv-single-map {\n  min-height: 0;\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--bg-card);\n  border: 2px solid var(--border-color);\n}\n\n.tv-single-forecast {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.tv-no-forecast {\n  padding: var(--spacing-lg);\n  text-align: center;\n  color: var(--text-muted);\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n}\n\n/* Grid View */\n.tv-grid-view {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--spacing-lg);\n  min-height: 0;\n}\n\n.tv-grid-item {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n/* Overview */\n.tv-overview {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.tv-overview-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--spacing-lg);\n  flex: 1;\n  min-height: 0;\n}\n\n.tv-overview-item {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-color);\n  padding: var(--spacing-md);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.tv-overview-map {\n  flex: 1;\n  min-height: 150px;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n\n/* Location Indicators */\n.tv-indicators {\n  display: flex;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md);\n}\n\n.indicator {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--text-muted);\n  background: transparent;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.indicator:hover {\n  border-color: var(--accent-blue);\n}\n\n.indicator.active {\n  background: var(--accent-blue);\n  border-color: var(--accent-blue);\n  transform: scale(1.2);\n}\n\n/* Controls Hint */\n.tv-controls-hint {\n  position: fixed;\n  bottom: var(--spacing-md);\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: var(--spacing-lg);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: var(--radius-md);\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  opacity: 0;\n  transition: opacity var(--transition-normal);\n  backdrop-filter: blur(8px);\n  z-index: 100;\n}\n\n.tv-display:hover .tv-controls-hint {\n  opacity: 1;\n}\n\n.tv-display.fullscreen .tv-controls-hint {\n  opacity: 0;\n}\n\n.tv-controls-hint kbd {\n  padding: 2px 6px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 0.75rem;\n}\n\n/* Back Link */\n.tv-back-link {\n  position: fixed;\n  top: var(--spacing-md);\n  left: var(--spacing-md);\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: 0.9rem;\n  opacity: 0;\n  transition: opacity var(--transition-normal);\n  backdrop-filter: blur(8px);\n  z-index: 100;\n}\n\n.tv-display:hover .tv-back-link {\n  opacity: 1;\n}\n\n.tv-back-link:hover {\n  background: rgba(0, 0, 0, 0.7);\n  color: var(--text-primary);\n}\n\n/* Progress Bar */\n.tv-progress-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--bg-secondary);\n  z-index: 50;\n}\n\n.tv-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent-blue), var(--accent-cyan));\n  animation: progress linear forwards;\n  width: 0;\n}\n\n@keyframes progress {\n  from { width: 0; }\n  to { width: 100%; }\n}\n\n/* Responsive */\n@media (max-width: 1400px) {\n  .tv-single-content {\n    grid-template-columns: minmax(240px, 280px) 1fr;\n  }\n}\n\n@media (max-width: 1100px) {\n  .tv-single-content {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n  }\n\n  .tv-single-ai {\n    max-height: 100px;\n  }\n\n  .tv-overview-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 800px) {\n  .tv-single-ai {\n    max-height: 80px;\n  }\n\n  .tv-overview-grid {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
